import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface Props extends Omit<ChakraV3.FormFieldsetProps, 'id'> {
  name: string;
}

export const HookedFormFieldset = (props: React.PropsWithChildren<Props>) => {
  const { name, ...rest } = props;
  const { formState } = useFormContext();

  const field = P.get(formState.errors, `${name}`) ?? undefined;

  const message: string | undefined = P.isArray<{ message: string }>(field)
    ? P.compact(field.map((item) => item?.message)).join(', ')
    : field?.message?.toString();

  return <ChakraV3.FormFieldset {...rest} id={name} errorText={message} />;
};
